module.exports = __webpack_public_path__ + "img/t1-6.a6a2ac60.png";